import { ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵdefineNgModule, ɵɵdefineInjector, NgModule, ɵɵinject, InjectionToken, Injector, ɵɵsetNgModuleScope } from '@angular/core';
import { HttpClient, HttpParams, HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { map, retryWhen, concatMap, delay, mergeMap } from 'rxjs/operators';
import { of, throwError, timer } from 'rxjs';
import { isNil, isDate, isArray, join } from 'lodash';
import { CommonModule } from '@angular/common';
import * as moment_ from 'moment';

class ApiInterceptor {
    intercept(req, next) {
        if (req.url.startsWith('./')) {
            return next.handle(req);
        }
        if (req.url.startsWith('http')) {
            return next.handle(req);
        }
        if (req.url.startsWith('/api/')) {
            return next.handle(req);
        }
        return next.handle(req.clone({
            url: '/api' + req.url
        }));
    }
}
ApiInterceptor.ɵfac = function ApiInterceptor_Factory(t) { return new (t || ApiInterceptor)(); };
ApiInterceptor.ɵprov = ɵɵdefineInjectable({ token: ApiInterceptor, factory: ApiInterceptor.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ApiInterceptor, [{
        type: Injectable
    }], null, null); })();

class DeviceDomainModule {
}
DeviceDomainModule.ɵmod = ɵɵdefineNgModule({ type: DeviceDomainModule });
DeviceDomainModule.ɵinj = ɵɵdefineInjector({ factory: function DeviceDomainModule_Factory(t) { return new (t || DeviceDomainModule)(); }, imports: [[]] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DeviceDomainModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: []
            }]
    }], null, null); })();

class ReservationHttpService {
    constructor(http) {
        this.http = http;
    }
    reserveDevice(reservation) {
        return this.http.post('/devices/reservations', reservation, { observe: 'response' })
            .pipe(map(resp => !!resp.body), retryWhen(errors => errors
            .pipe(concatMap((error, count) => {
            if (count < 5 && (error.status === 400 || error.status === 0)) {
                return of(error.status);
            }
            return throwError(error);
        }), delay(1000))));
    }
    getCurrentReservation(deviceId) {
        return this.http.get('/devices/' + deviceId + '/reservations/current');
    }
    putReservation(reservation) {
        return this.http.put('/reservations', reservation);
    }
    cancelReservation(id) {
        return this.http.delete('/devices/reservations/' + id).pipe(retryWhen(errors => errors
            .pipe(concatMap((error, count) => {
            if (count < 5 && (error.status === 400 || error.status === 0)) {
                return of(error.status);
            }
            return throwError(error);
        }), delay(1000))));
    }
}
ReservationHttpService.ɵfac = function ReservationHttpService_Factory(t) { return new (t || ReservationHttpService)(ɵɵinject(HttpClient)); };
ReservationHttpService.ɵprov = ɵɵdefineInjectable({ token: ReservationHttpService, factory: ReservationHttpService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ReservationHttpService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HttpClient }]; }, null); })();

class HttpParamsUtil {
    static toHttpParams(originalParams) {
        if (isNil(originalParams)) {
            return new HttpParams();
        }
        return Object.getOwnPropertyNames(originalParams)
            .filter((key) => {
            const param = originalParams[key];
            return !isNil(param) && param !== '';
        })
            .reduce((params, key) => {
            return HttpParamsUtil.aggregate(params, key, originalParams);
        }, new HttpParams());
    }
    static aggregate(params, key, originalParams) {
        const param = originalParams[key];
        if (isDate(param)) {
            return params.set(key, param.toISOString());
        }
        if (isArray(param)) {
            params = params.append(key, join(param, ','));
            return params;
        }
        return params.set(key, param);
    }
}

class DeviceHttpService {
    constructor(http) {
        this.http = http;
    }
    getDevices() {
        return this.http.get('/devices');
    }
    getUnpairedDevices() {
        return this.http.get('/devices/unpaired');
    }
    getById(id) {
        return this.http.get('/devices/' + id);
    }
    getSimilar(id) {
        return this.http.get('/devices/' + id + '/similar');
    }
    getBySearchInfo(searchInfo) {
        return this.http.get('/devices', { params: HttpParamsUtil.toHttpParams(searchInfo) });
    }
    getOSs() {
        return this.http.get('/devices/oss'); // use reference page?
    }
    getTypes() {
        return this.http.get('/devices/types');
    }
    putDevice(device) {
        return this.http.put('/devices', device);
    }
}
DeviceHttpService.ɵfac = function DeviceHttpService_Factory(t) { return new (t || DeviceHttpService)(ɵɵinject(HttpClient)); };
DeviceHttpService.ɵprov = ɵɵdefineInjectable({ token: DeviceHttpService, factory: DeviceHttpService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DeviceHttpService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HttpClient }]; }, null); })();

const FRONT_ORIGIN = new InjectionToken('Origin identifier');
class FrontOriginInterceptor {
    constructor(injector) {
        this.injector = injector;
    }
    intercept(req, next) {
        const frontOrigin = this.injector.get(FRONT_ORIGIN);
        return next.handle(req.clone({
            headers: req.headers.append('X-FRONT-ORIGIN', frontOrigin)
        }));
    }
}
FrontOriginInterceptor.ɵfac = function FrontOriginInterceptor_Factory(t) { return new (t || FrontOriginInterceptor)(ɵɵinject(Injector)); };
FrontOriginInterceptor.ɵprov = ɵɵdefineInjectable({ token: FrontOriginInterceptor, factory: FrontOriginInterceptor.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FrontOriginInterceptor, [{
        type: Injectable
    }], function () { return [{ type: Injector }]; }, null); })();

class UserHttpService {
    constructor(http) {
        this.http = http;
    }
    getUsers() {
        return this.http.get('/users');
    }
}
UserHttpService.ɵfac = function UserHttpService_Factory(t) { return new (t || UserHttpService)(ɵɵinject(HttpClient)); };
UserHttpService.ɵprov = ɵɵdefineInjectable({ token: UserHttpService, factory: UserHttpService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UserHttpService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }]; }, null); })();

class ApiInfoHttpService {
    constructor(http) {
        this.http = http;
    }
    getServerInfo() {
        return this.http.get('/info');
    }
}
ApiInfoHttpService.ɵfac = function ApiInfoHttpService_Factory(t) { return new (t || ApiInfoHttpService)(ɵɵinject(HttpClient)); };
ApiInfoHttpService.ɵprov = ɵɵdefineInjectable({ token: ApiInfoHttpService, factory: ApiInfoHttpService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ApiInfoHttpService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HttpClient }]; }, null); })();

class FileHttpService {
    constructor(http) {
        this.http = http;
    }
    deleteFile(deviceId, fileId) {
        return this.http.delete('/devices/' + deviceId + '/files/' + fileId);
    }
    getFilesInFolder(folderPath, deviceId) {
        const searchParams = { path: folderPath };
        return this.http.get('/devices/' + deviceId + '/files', { params: HttpParamsUtil.toHttpParams(searchParams) });
    }
    getRecentFiles(deviceId, limit = null) {
        return this.http.get('/devices/' + deviceId + '/files/recent', { params: HttpParamsUtil.toHttpParams({ limit }) });
    }
    postFile(base64Data, deviceFile, deviceId) {
        const blob = this.base64toBlob(base64Data);
        const formData = new FormData();
        formData.append('file', blob);
        formData.append('name', deviceFile.name);
        formData.append('contentType', deviceFile.contentType);
        formData.append('path', deviceFile.path);
        return this.http.post('/devices/' + deviceId + '/files', formData);
    }
    patchFile(deviceFile, deviceId, fileId) {
        return this.http.patch('/devices/' + deviceId + '/files/' + fileId, deviceFile);
    }
    base64toBlob(b64Data, contentType = '', sliceSize = 512) {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
}
FileHttpService.ɵfac = function FileHttpService_Factory(t) { return new (t || FileHttpService)(ɵɵinject(HttpClient)); };
FileHttpService.ɵprov = ɵɵdefineInjectable({ token: FileHttpService, factory: FileHttpService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FileHttpService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }]; }, null); })();

class DeviceHttpModule {
}
DeviceHttpModule.ɵmod = ɵɵdefineNgModule({ type: DeviceHttpModule });
DeviceHttpModule.ɵinj = ɵɵdefineInjector({ factory: function DeviceHttpModule_Factory(t) { return new (t || DeviceHttpModule)(); }, providers: [
        [
            {
                provide: HTTP_INTERCEPTORS,
                useClass: ApiInterceptor,
                multi: true
            },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: FrontOriginInterceptor,
                multi: true
            }
        ],
        DeviceHttpService,
        ApiInfoHttpService,
        FileHttpService,
        ReservationHttpService,
        UserHttpService
    ], imports: [[HttpClientModule, RouterModule, DeviceDomainModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(DeviceHttpModule, { imports: [HttpClientModule, RouterModule, DeviceDomainModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(DeviceHttpModule, [{
        type: NgModule,
        args: [{
                imports: [HttpClientModule, RouterModule, DeviceDomainModule],
                providers: [
                    [
                        {
                            provide: HTTP_INTERCEPTORS,
                            useClass: ApiInterceptor,
                            multi: true
                        },
                        {
                            provide: HTTP_INTERCEPTORS,
                            useClass: FrontOriginInterceptor,
                            multi: true
                        }
                    ],
                    DeviceHttpService,
                    ApiInfoHttpService,
                    FileHttpService,
                    ReservationHttpService,
                    UserHttpService
                ]
            }]
    }], null, null); })();

class DeviceStorageService {
    save(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    }
    get(key) {
        return JSON.parse(localStorage.getItem(key));
    }
    delete(key) {
        localStorage.setItem(key, undefined);
    }
}
DeviceStorageService.ɵfac = function DeviceStorageService_Factory(t) { return new (t || DeviceStorageService)(); };
DeviceStorageService.ɵprov = ɵɵdefineInjectable({ token: DeviceStorageService, factory: DeviceStorageService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DeviceStorageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class DeviceStorageModule {
}
DeviceStorageModule.ɵmod = ɵɵdefineNgModule({ type: DeviceStorageModule });
DeviceStorageModule.ɵinj = ɵɵdefineInjector({ factory: function DeviceStorageModule_Factory(t) { return new (t || DeviceStorageModule)(); }, providers: [DeviceStorageService], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(DeviceStorageModule, { imports: [CommonModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(DeviceStorageModule, [{
        type: NgModule,
        args: [{
                providers: [DeviceStorageService],
                declarations: [],
                imports: [
                    CommonModule
                ]
            }]
    }], null, null); })();

const services = [DeviceHttpModule, DeviceStorageModule];
class DeviceServicesModule {
}
DeviceServicesModule.ɵmod = ɵɵdefineNgModule({ type: DeviceServicesModule });
DeviceServicesModule.ɵinj = ɵɵdefineInjector({ factory: function DeviceServicesModule_Factory(t) { return new (t || DeviceServicesModule)(); }, imports: [[
            services
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(DeviceServicesModule, { imports: [DeviceHttpModule, DeviceStorageModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(DeviceServicesModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    services
                ]
            }]
    }], null, null); })();

class LibDevicesModule {
}
LibDevicesModule.ɵmod = ɵɵdefineNgModule({ type: LibDevicesModule });
LibDevicesModule.ɵinj = ɵɵdefineInjector({ factory: function LibDevicesModule_Factory(t) { return new (t || LibDevicesModule)(); }, imports: [[DeviceServicesModule, DeviceDomainModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(LibDevicesModule, { imports: [DeviceServicesModule, DeviceDomainModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(LibDevicesModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [DeviceServicesModule, DeviceDomainModule],
                exports: []
            }]
    }], null, null); })();

const RetryStrategy = ({ maxRetryAttempts, scalingDuration = 1000, excludedStatusCodes = [] } = {}, attemptNb) => (attempts) => {
    return attempts.pipe(mergeMap((error, i) => {
        const retryAttempt = attemptNb ? attemptNb() : i + 1;
        if ((!maxRetryAttempts && retryAttempt > maxRetryAttempts) ||
            excludedStatusCodes.find(e => e === error.status)) {
            return throwError(error);
        }
        console.log(`Attempt ${retryAttempt}: retrying in ${retryAttempt * scalingDuration}ms`);
        return timer(retryAttempt * scalingDuration);
    }));
};

class Project {
    constructor(name, logoUrl) {
        this.name = name;
        this.logoUrl = logoUrl;
    }
}
var DeviceAvailability;
(function (DeviceAvailability) {
    DeviceAvailability["AVAILABLE"] = "AVAILABLE";
    DeviceAvailability["TAKEN"] = "TAKEN";
    DeviceAvailability["BROKEN"] = "BROKEN";
})(DeviceAvailability || (DeviceAvailability = {}));
var DeviceType;
(function (DeviceType) {
    DeviceType["TABLET"] = "TABLET";
    DeviceType["MOBILE"] = "MOBILE";
    DeviceType["NULL"] = "NULL";
})(DeviceType || (DeviceType = {}));

var ReservationType;
(function (ReservationType) {
    ReservationType["ONE_HOUR"] = "ONE_HOUR";
    ReservationType["TWO_HOURS"] = "TWO_HOURS";
    ReservationType["MORNING"] = "MORNING";
    ReservationType["AFTERNOON"] = "AFTERNOON";
    ReservationType["DAY"] = "DAY";
    ReservationType["BY_END_DATE"] = "BY_END_DATE";
})(ReservationType || (ReservationType = {}));

class UserReference {
    constructor(userId, userName, userCode) {
        this.userId = userId;
        this.userName = userName;
        this.userCode = userCode;
    }
}

class OsBlock {
    constructor(userReference, comment) {
        this.userReference = userReference;
        this.comment = comment;
    }
}

const CURRENT_USER = 'CURRENT_USER';

const moment = moment_;
const END_OF_DAY_TIME_HOURS = 20;
const END_OF_DAY_TIME_MINUTES = 0;
class ReservationUtil {
    static getReservationBounds(reservationType, endDate) {
        const startTime = moment();
        let endTime = moment();
        switch (reservationType) {
            case ReservationType.ONE_HOUR:
                endTime.add(1, 'hours');
                break;
            case ReservationType.TWO_HOURS:
                endTime.add(2, 'hours');
                break;
            case ReservationType.MORNING:
                endTime.hour(12);
                endTime.minute(0);
                break;
            case ReservationType.AFTERNOON:
                if (!this.isAfternoon()) {
                    startTime.hour(12);
                    startTime.minute(0);
                }
                endTime.hour(END_OF_DAY_TIME_HOURS);
                endTime.minute(END_OF_DAY_TIME_MINUTES);
                break;
            case ReservationType.DAY:
                endTime.hour(END_OF_DAY_TIME_HOURS);
                endTime.minute(END_OF_DAY_TIME_MINUTES);
                break;
            case ReservationType.BY_END_DATE:
                endTime = moment(endDate, 'YYYY-MM-DD').hours(END_OF_DAY_TIME_HOURS).minutes(0);
                break;
        }
        return [startTime, endTime];
    }
    static isAfternoon() {
        const date = new Date();
        return date.getHours() >= 12;
    }
}

var FrontOrigin;
(function (FrontOrigin) {
    FrontOrigin["USER"] = "USER";
    FrontOrigin["ADMIN"] = "ADMIN";
    FrontOrigin["MOBILE"] = "MOBILE";
})(FrontOrigin || (FrontOrigin = {}));

const moment$1 = moment_;
const momentFilesCalendarFormats = {
    sameDay: '[Aujourd’hui]',
    lastDay: '[Hier]',
    sameWeek: 'dddd D MMMM',
    lastWeek: 'dddd D MMMM',
    sameElse: 'L'
};
class DeviceFileUtil {
    static getKeyFromTimeDiff(timeDiff, timeDiffSeparators) {
        console.log(timeDiff);
        for (let i = 0; i < timeDiffSeparators.length; i++) {
            if (timeDiff < timeDiffSeparators[i]) {
                return i;
            }
        }
        return timeDiffSeparators.length;
    }
    static getFileGroupLabelFromKey(key, translateService, timeDiffSeparators, fileCreationMoment) {
        if (key === -1) {
            return translateService.instant('label.folders');
        }
        else if (key === timeDiffSeparators.length) {
            return translateService
                .instant('files.orBefore', {
                timeAgo: fileCreationMoment
                    .calendar(null, momentFilesCalendarFormats)
            });
        }
        else {
            return fileCreationMoment.calendar(null, momentFilesCalendarFormats);
        }
    }
    static getTimeDiffInDays(currentMoment, fileCreationMoment) {
        currentMoment.set('hours', 1);
        currentMoment.set('minutes', 1);
        fileCreationMoment.set('hours', 1);
        fileCreationMoment.set('minutes', 1);
        return Math.abs(currentMoment.diff(fileCreationMoment, 'days'));
    }
    static makeDeviceFileGroups(files, timeDiffSeparators, translateService) {
        const tempFileGroups = [];
        const currentMoment = moment$1();
        for (const file of files) {
            const fileCreationMoment = moment$1(file.creationDate);
            const timeDiffMinutes = this.getKeyFromTimeDiff(this.getTimeDiffInDays(currentMoment, fileCreationMoment), timeDiffSeparators);
            const fileKey = file.contentType === 'folder' ? -1 : timeDiffMinutes;
            const groupIndex = tempFileGroups.findIndex(fileGroup => fileGroup.key === fileKey);
            if (groupIndex > -1) {
                tempFileGroups[groupIndex].files.push(file);
            }
            else {
                tempFileGroups.push({
                    key: fileKey,
                    label: this.getFileGroupLabelFromKey(fileKey, translateService, timeDiffSeparators, fileCreationMoment),
                    files: [file]
                });
            }
        }
        tempFileGroups.sort((a, b) => a.key >= b.key ? 1 : -1);
        return tempFileGroups;
    }
}

/*
 * Public API Surface of lib-devices
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ApiInfoHttpService, ApiInterceptor, CURRENT_USER, DeviceAvailability, DeviceDomainModule, DeviceFileUtil, DeviceHttpModule, DeviceHttpService, DeviceServicesModule, DeviceStorageModule, DeviceStorageService, DeviceType, FRONT_ORIGIN, FileHttpService, FrontOrigin, FrontOriginInterceptor, HttpParamsUtil, LibDevicesModule, OsBlock, Project, ReservationHttpService, ReservationType, ReservationUtil, RetryStrategy, UserHttpService, UserReference };
//# sourceMappingURL=lib-devices.js.map
